import {
    GET_APPLICATION_DOCUMENTS,
    get_headers,
} from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import formatting_mixins from '@/utils/mixins/formatting_mixins';
import axios from 'axios';


export default {
    name: 'EntityDocuments',
    mixins: [alert_mixin, formatting_mixins],
    props: {
        application_id: { type: [String, Number], default: null },
        entity_profile_id: { type: [String, Number], default: null },
    },
    data: () => ({
        headers: get_headers(),
        documents: [],
        selected_document: null,
        table_safe_documents: [],
        preview_url: null,
        preview_modal: false,
        active_tab: "All",
        tabs: [
        "All",
        "Governance",
        "Reports"
        ],
        came_from_dashboard: false,

    }),
    mounted() {
        this.came_from_dashboard = sessionStorage.getItem('came_from_dashboard') === 'true';
        sessionStorage.removeItem('came_from_dashboard');
    },


    computed: {
        resolved_application_id() {
            return this.application_id ?? this.$route?.query?.application_id ?? null;
        }
    },

    watch: {
        resolved_application_id: {
            immediate: true,
            handler(newVal) {
                this.selected_document = null;
                this.documents = [];
                this.table_safe_documents = [];

                if (newVal) {
                    this.get_documents();
                }
            }
        }
    },


    methods: {
        async set_active_tab(tab) {
            this.active_tab = tab;
            localStorage.setItem("active_tab", tab);
        },

        select_document(doc) {
            this.selected_document = doc;
        },

        get_documents() {
            if (!this.resolved_application_id) {
                this.selected_document = null;
                this.table_safe_documents = [];
                return;
            }

            this.documents = [];
            axios.get(GET_APPLICATION_DOCUMENTS, {
                headers: this.headers,
                params: {
                    application_id: this.resolved_application_id,
                    ...(this.entity_profile_id ? { entity_profile_id: this.entity_profile_id } : {}),
                }
            })
                .then(response => {
                    const parsed_response = response.data;
                    if (parsed_response.data && parsed_response.data.length > 0) {
                        this.documents = parsed_response.data;
                        this.transform_documents_data();
                    } else {
                        this.documents = [];
                        this.table_safe_documents = [];
                        this.selected_document = null;
                    }
                })
                .catch(error => {
                    this.show_error("Error loading documents: " + (error.response?.data?.message || error.message));
                });
        },

        transform_documents_data() {
            if (this.documents.length > 0) {
                const TABLE_DOC_DATA = this.documents.map((document, index) => ({
                    no: index + 1,
                    file_name: document.file_name,
                    section: document.section,
                    submitted_on: document.submitted_on,
                    presigned_url: document.presigned_url,
                    status: document.is_verified ? 'Verified' : 'Pending Verification',
                    is_verified: document.is_verified,
                    verification_comment: document.verification_comment,
                    date_verified: this.format_date(document.date_verified),
                    section_question_id: document.section_question_id,
                }));

                this.table_safe_documents = TABLE_DOC_DATA;
            } else {
                this.table_safe_documents = [];
                this.selected_document = null;
            }

        },

        preview_file(presigned_url) {
            if (!presigned_url) {
                this.show_error("Preview URL is missing.");
                return;
            }

            this.preview_url = presigned_url;
            this.preview_modal = true;

        },
        download_file(url, file_name) {
            if (!url) {
                this.show_error("Download URL is missing.");
                return;
            }

            const downloadUrl = url

            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', file_name || 'document.pdf');
            link.setAttribute('target', '_blank');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },

          go_back_to_dashboard() {
            this.$router.push({ path: '/founder_dashboard' }); // adjust path as needed
        }

    }
};
